module.exports = __webpack_public_path__ + "static/media/NuloPetFood-JordanHicks.3c27b842.jpg";